import { ParkingStatuses } from '@aggregator/core';
import { enumToDescriptedArray } from '@shared/core';
import { FormFieldType, IFormGroupConfig } from '@shared/ui';

export const parkingMapFilterFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  fields: {
    parkingId: {
      type: FormFieldType.SELECT,
      label: 'Название парковки:',
      placeholder: 'Введите название',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'parkings',
    },
    operatorId: {
      type: FormFieldType.SELECT,
      label: 'Оператор:',
      placeholder: 'Укажите оператора',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'operators',
      pageable: true,
    },
    typeId: {
      type: FormFieldType.SELECT,
      label: 'Тип:',
      placeholder: 'Укажите тип',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'parking-types',
    },
    categoryId: {
      type: FormFieldType.SELECT,
      label: 'Категория',
      placeholder: 'Укажите категория',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'categories',
    },
    status: {
      type: FormFieldType.SELECT,
      label: 'Статус:',
      placeholder: 'Укажите статус',
      options: enumToDescriptedArray(ParkingStatuses),
      optionLabelField: 'description',
      optionValueField: 'id',
    },
  },
};
